module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Adress-book1-84da26b0f226dccebe900e2af5729488.svg";